import { render } from "./CookiesBanner.vue?vue&type=template&id=0ddf1413&scoped=true"
import script from "./CookiesBanner.vue?vue&type=script&lang=js"
export * from "./CookiesBanner.vue?vue&type=script&lang=js"

import "./CookiesBanner.vue?vue&type=style&index=0&id=0ddf1413&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddf1413"]])

export default __exports__